import axios, { InternalAxiosRequestConfig } from 'axios';
import { getToken } from './keycloak-wrapper';
import { api_config } from '@/env';

// Create axios instance with base configuration
const axiosInstance = axios.create({
    baseURL: api_config.backend,
    timeout: 60000, // 60 seconds duue to potential slow ftp transfers
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request interceptor to add auth token
axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        try {
            const token = await getToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Failed to get auth token:', error);
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
